// extracted by mini-css-extract-plugin
module.exports = {"navitems":"navigationitems_navitems__2aCH2","span":"navigationitems_span__3Lt1Z"};